const contentWrapper = "_uw7c10321si";
const gridWrapper = "_uw7g3hs3ce";
const sliderWrapper = "_uw7sc7si3z";
const componentFrameworkWrapper = "_uw7cqwpf5f";
const withToolbarWrapper = "_uw7w1x1wlfw";
const withToolbarContainer = "_uw7w1ku5031";
const fallbackWrapper = "_uw7fcqb5kz";

export { componentFrameworkWrapper, contentWrapper, fallbackWrapper, gridWrapper, sliderWrapper, withToolbarContainer, withToolbarWrapper };
import "./pm2-modal.style.linaria.module.css";
//# sourceMappingURL=pm2-modal.style.js.map
